import React from "react";

const RequiredIndicator = () => {
    
      return (
        <sup style={{ fontSize: "medium", top: 0 }} className="text-danger fs-1">*</sup>
      );
    
  };

export default RequiredIndicator;
